if ($(".wrapper-trend").length) {
  $(window).on("load", function () {
    if (window.matchMedia && window.matchMedia("(min-device-width: 767px)").matches) {
      //画像の整列
      let s_area = $(".suggestion__area__imgs").length;
      s_area = s_area - 1;
      $(".suggestion__area__imgs").each(function (index, element) {
        let img_lists = $(this).find(".img_list").length;
        img_lists = 100 / img_lists;
        $(this)
          .find(".img_list")
          .css("width", img_lists + "%");
        s_area = s_area + 1;
      });
    } else {
      $(".p-ft__gotop").css("bottom", "90px");
      let navi_position = $(window).height();
      let wrap = $(".wrapper-trend").height();
      //navi表示域 - デバイスの高さ + headerの高さ
      wrap = wrap - navi_position + 220;
      $(window).on("scroll", function () {
        let winodw_height = $(window).scrollTop();
        let navi_display = $(".trend-navi").css("display");
        //naviの表示・非表示
        if (navi_display === "block") {
          if (winodw_height > wrap) {
            $(".trend-navi").fadeOut();
          }
        } else {
          if (winodw_height < wrap) {
            $(".trend-navi").fadeIn();
          }
        }
      });
    }
  });
}

const catNav = $(".trendArch__contentsNav");
const trendURL = new URL(location);
/*
if (catNav.length) {
  $(function () {
    const $spNav = $(".trendArch__select");
    $spNav.on("change", function () {
      $(`[data-filter_term="${$(this).val()}"]`).trigger("click");
    });

    let clickTerm = "";
    $(".trendArch__filterWrap input").on("click", function (e) {
      if (clickTerm === $(this).data("filter_term")) return;
      clickTerm = $(this).data("filter_term");
      $("#sec_market .addLead").text(cat_desc_array[clickTerm]);
      $spNav.val(clickTerm);
      trendURL.searchParams.set("category", clickTerm);
      history.replaceState("", "", trendURL.toString());
    });

    // マーケットカテゴリ指定のURLの場合
    let urlParam = trendURL.searchParams.get("category");

    if (urlParam && urlParam !== "") {
      $spNav.val(urlParam).trigger("change");
    }

    // URLに#sec_technology付きの場合コンテンツをテクノロジーに切り替える
    if (trendURL.hash == "#sec_technology") {
      $("#sec_technology a").trigger("click");
    }

    // Gナビ内の「マーケット」「テクノロジー」がクリックされた際に、それぞれのコンテンツに切り替える
    $(".p-hdChild__navBlock.-trend a[href^='#sec_'], .p-spNav__nav a[href^='#sec_'].-trend").on("click", function () {
      const secName = $(this).attr("href");
      $(secName + "> a").trigger("click");
    });
  });
}
*/
if ($(".p-trend-v2__navList").length > 0) {
  const sug = $(".p-trend-v2__navList a.suggAnchor");
  sug.on("click", function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
  });

  const anchorSelect = $(".p-trend-v2__suggAnchorBox select");
  anchorSelect.on("change", function () {
    let valID = $(this).val();
    if (valID == "") return;

    let aTag = $("<a>", {
      href: valID,
      css: {
        position: "fixed",
        top: "0",
        left: "0",
        opacity: "0",
        zIndex: 0,
      },
    });
    const fixedBlockSelector = anchorSelect.data("fixedblock");
    if (fixedBlockSelector) {
      if ($(fixedBlockSelector).length > 0) {
        aTag.attr("data-fixedblock", fixedBlockSelector);
      }
    }

    $("body").append(aTag);
    setTimeout(function () {
      aTag.trigger("click");
      aTag.remove();
      sug.removeClass("active");
    }, 10);

    // 選択を初期に戻す
    anchorSelect.val("");
  });

  $(".p-trend-v2__scroll").on("scroll", function () {
    sug.removeClass("active");
  });
  $('.p-trend-v2__navList a:not(".suggAnchor")').on("click", function () {
    sug.removeClass("active");
  });
}
